import { createAction, props } from "@ngrx/store";
import { ISkillGroup } from "@skills-app/models/skillGroup";

const prefix = "[Update Skill Groups Page]";

export const loadPage = createAction(`${prefix} Load Page`);

export const selectSkillGroup = createAction(
  `${prefix} Select Skill Group`,
  props<{ skillGroup: ISkillGroup }>(),
);

export const clearSkillGroupSelection = createAction(
  `${prefix} Clear Skill Group`,
);

export const editSkillDialogClosed = createAction(
  `${prefix} Edit Skill Dialog Closed`,
);
export const deleteSkillDialogClosed = createAction(
  `${prefix} Delete Skill Dialog Closed`,
);
